exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-paragraph {\n  padding: 0.4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/factory.less
// module id = 211
// module chunks = 0